<template>
  <v-autocomplete
      v-model="selected_items"
      :items="displayItems"
      :label="label"
      :item-text="itemText"
      :item-value="itemId"
      :multiple="isMultiple"
      solo
      hide-details="auto"
      class="input-base"
       append-icon="$caretDownFormIcon"
      :filter="custom_filter ? custom_filter : (useRemote ? alwaysTrue : filterObject)"
      @update:search-input="handleSearchInput"
  >
    <template v-slot:item="data">
      <v-list-item-content>
        <v-list-item-title>
          <span v-if="data.item._loading">{{ data.item[itemText] }}</span>
          <span v-else>
            <slot name="list_selection" :selection="data.item">
              {{ data.item[itemText] }}
            </slot>
          </span>
        </v-list-item-title>
      </v-list-item-content>
    </template>

    <template v-slot:selection="data">
      <v-chip v-if="isMultiple" close @click:close="remove(data.item)">
        {{ data.item[itemText] }}
      </v-chip>
      <v-chip v-else>{{ data.item[itemText] }}</v-chip>
    </template>
  </v-autocomplete>
</template>

<script>
import debounce from "lodash/debounce";

export default {
  props: {
  limit_show: {
      type: Number,
      default: 2,
    },
    items: Array,
    itemId: { type: String, default: "id" },
    itemText: { type: String, default: "name" },
    isMultiple: { type: Boolean, default: true },
    formatSelected: {
      type: String,
      default: "normal",
      validator(value) {
        return ["clips", "normal"].includes(value);
      },
    },
    item_selected: {
      type: Function,
      default: (item,item_text) => item[item_text]
    },
    label: { type: String, default: "Autocomplete" },
    onSearch: Function,
    loading: { type: Boolean, default: false },

    custom_filter: Function,
  },
  data() {
    return {
      selected_items: [],
      useRemote: !!this.onSearch,
      internalLoading: false,
    };
  },

  watch: {
    selected_items(val) {
      this.$emit("selected", val);
    },
    isUpdating(val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000);
      }
    },
  },
  computed: {
    displayItems() {
      if (this.internalLoading) {
        return [{_loading: true, [this.itemText]: "Buscando..."}];
      }
      return this.items || [];
    },
  },
  methods: {
    alwaysTrue() {
      return true;
    },
    handleSearchInput: debounce(async function (query) {
      if (!this.useRemote) return;
      if (!query || query.length < 2) {
        this.internalLoading = false;
        return;
      }
      this.internalLoading = true;
      try {
        if (this.onSearch) await this.onSearch(query);
      } finally {
        this.internalLoading = false;
      }
    }, 300),
    filterObject(item, query, text) {
      return item[text] && item[text].toLowerCase().includes(query.toLowerCase());
    },
    remove(item) {
      this.selected_items = this.selected_items.filter((i) => i !== item[this.itemId]);
    },
    selection_item(data) {
      const text = this.item_selected(data.item,this.itemText);
      console.log();
      const last_items =
        Math.abs(data.index - this.selected_items.length) <=
        this.limit_show + 1;

      return last_items ? /*  coma_validate +  */ text : ""; // + continue_text;
    },
    filterObject(item, queryText, itemText) {
      return this.custom_filter(item, queryText, this.itemText);
    }
  },
};
</script>
